module.exports = __webpack_public_path__ + "bd010910f5845a9ded0fd9f9faf8dfb6.svg";